export default __webpack_public_path__ + "static/media/0007BLEU.71bb60bf.pdf";